import React from 'react';
import {ExportBuilder} from './ExportBuilder';

export const ExportContext = React.createContext<ExportBuilder | null>(null);
